import { ArrowDropDown } from '@mui/icons-material';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { SxProps } from '@mui/system';
import Loading from 'components/Loading';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    useGetAvailableDemoFinanceSoftwares,
    useGetCurrentDemoFinanceSoftware,
    useUpdateDemoFinanceSoftware,
} from 'routes/BudgetModule/components/shared/BudgetHeader/hooks';

type Props = {
    sx?: SxProps;
};

const FinanceSoftwareOverrideSelector = ({
    sx = undefined,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const {
        data: softwareName,
        isLoading: isLoadingCurrent,
        isError: isCurrentError,
    } = useGetCurrentDemoFinanceSoftware({ enabled: true });
    const { data: availableSoftwares, isError: isAvailableError } =
        useGetAvailableDemoFinanceSoftwares();
    const { mutate: updateFinanceSoftware, isPending: isLoadingUpdate } =
        useUpdateDemoFinanceSoftware();
    if (isLoadingCurrent || isCurrentError || isAvailableError) return <></>;
    const options = availableSoftwares?.map((software) => (
        <MenuItem key={software} value={software}>
            {software}
        </MenuItem>
    ));
    const label = t('budget.financeSoftwareSelectorLabel');
    return (
        <FormControl sx={sx}>
            <InputLabel htmlFor="finance-software-selector">{label}</InputLabel>
            <Select
                id="finance-software-selector"
                value={softwareName}
                label={label}
                IconComponent={isLoadingUpdate ? Loading : ArrowDropDown}
                onChange={(event) => updateFinanceSoftware(event.target.value)}
            >
                {options}
            </Select>
        </FormControl>
    );
};

export default FinanceSoftwareOverrideSelector;
